// extracted by mini-css-extract-plugin
export var actionButton = "_cm-0";
export var attachmentLine = "_cm-1";
export var fileInput = "_cm-2";
export var fileUploadWrapper = "_cm-4";
export var footer = "_cm-3";
export var modalContent = "_cm-5";
export var paperclip = "_cm-6";
export var quillEditor = "_cm-7";